export default {
    props: {
        name: {
            type: String,
            default: undefined,
            kComposite: 'name'
        }, 
        template: {
            type: [String, Function],
            default: undefined,
            kComposite: 'template'
        }, 
        text: {
            type: String,
            default: undefined,
            kComposite: 'text'
        }
    }
}


// WEBPACK FOOTER //
// ./packages/kendo-gantt-vue-wrapper/src/KendoGanttToolbar/Toolbar.js